import { Component, inject } from '@angular/core';
import { HolidayDateService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  HolidayDateCreateDto,
  HolidayDateDto,
  HolidayDateExcelDownloadDto,
  HolidayDateUpdateDto,
} from 'orchestrator';
import { HOLIDAYDATE_CONFIG, HOLIDAYDATE_FIELDS } from './holiday-date.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-holiday-date',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, HolidayDateService, ConfirmationService],
  templateUrl: './holiday-date.html',
  styleUrl: './holiday-date.scss',
})
export class HolidayDate extends BaseCrudComponent<
  HolidayDateDto,
  HolidayDateCreateDto,
  HolidayDateUpdateDto,
  HolidayDateExcelDownloadDto
> {
  service = inject(HolidayDateService);
  config = HOLIDAYDATE_CONFIG;
  fields = HOLIDAYDATE_FIELDS;

  protected prepareUpdateDto(data: any, selected: HolidayDateDto): HolidayDateUpdateDto {
    return {
      date: data.date,
      holidayId: data.holidayId,
      vendorId: data.vendorId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'HolidayDate';
  }
}
